import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  ["/", "Home"],
  ["/courses", "Courses"],
  ["/about", "About Us"],
  ["/student-verification", "Verify"],
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-white/5 bg-deep-black/90 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4">
        
        {/* GITSI LOGO */}
        <Link to="/" className="flex items-center">
          <img
            src="/gitsi-logo.png"
            alt="GITSI Institute"
            className="h-10 w-auto object-contain"
          />
        </Link>

        {/* DESKTOP NAVIGATION */}
        <nav className="hidden gap-2 md:flex">
          {links.map(([to, label]) => (
            <Link
              key={to}
              to={to}
              className="rounded-full px-4 py-2 text-sm text-white/70 hover:text-neon-green"
            >
              {label}
            </Link>
          ))}
        </nav>

        {/* DESKTOP LOGIN */}
        <div className="hidden md:block">
          <Link
            to="/login"
            className="btn-ghost-neon !px-4 !py-2 text-sm"
          >
            Login
          </Link>
        </div>

        {/* MOBILE MENU BUTTON */}
        <button
          className="md:hidden"
          onClick={() => setOpen(!open)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {/* MOBILE MENU */}
      {open && (
        <div className="border-t border-white/5 p-4 md:hidden">
          {links.map(([to, label]) => (
            <Link
              key={to}
              to={to}
              onClick={() => setOpen(false)}
              className="block p-3 text-white/80"
            >
              {label}
            </Link>
          ))}

          <Link
            to="/login"
            onClick={() => setOpen(false)}
            className="btn-neon mt-2 w-full"
          >
            Login
          </Link>
        </div>
      )}
    </header>
  );
}